export const SHOW_ERROR = "SHOW_ERROR";
export const UPDATE_ERROR = "UPDATE_ERROR";
